import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("g", {
      fill: "none",
      children: /*#__PURE__*/_jsx("path", {
        d: "M7.153 17.978c-1.497 1.498-.97 4.232.603 5.806 1.573 1.573 4.309 2.1 5.806.603L24.408 13.54c1.164-1.164 1.117-3.101-.107-4.325-1.224-1.223-3.16-1.272-4.325-.106l-9.64 9.64c-.832.832-.963 1.669-.09 2.542.874.874 1.71.743 2.542-.09l8.435-8.435a.436.436 0 0 0-.015-.617.437.437 0 0 0-.617-.015l-8.436 8.436c-.499.499-.783.645-1.307.12-.525-.524-.38-.806.12-1.307l9.642-9.64c.832-.833 2.213-.8 3.088.076.874.874.909 2.256.077 3.088l-9.143 9.143-1.703 1.703c-1.165 1.165-3.347.65-4.57-.573-1.224-1.223-1.737-3.405-.573-4.57l1.704-1.703 7.937-7.938a.436.436 0 0 0-.016-.616.437.437 0 0 0-.618-.016l-8.079 8.08-1.561 1.561",
        fill: "currentColor"
      })
    })
  }));
};
export default SvgComponent;